"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTaskManagedAttributeMetaData = void 0;
var types_1 = require("@bringg/types");
var task_managed_attributes_types_1 = require("./task_managed_attributes_types");
var attributeToDataTypeMapping = (_a = {},
    _a[task_managed_attributes_types_1.TaskManagedAttributesNames.TenderNotifyStatus] = {
        values: [
            { key: types_1.TenderNotifyStatus.Tender, value: 'Tender' },
            { key: types_1.TenderNotifyStatus.Contact, value: 'Contact' },
            { key: types_1.TenderNotifyStatus.Appointed, value: 'Appointed' }
        ]
    },
    _a[task_managed_attributes_types_1.TaskManagedAttributesNames.FloatingHelperTaskId] = { type: types_1.AttributeDatatype.Number },
    _a[task_managed_attributes_types_1.TaskManagedAttributesNames.MeetupTaskId] = { type: types_1.AttributeDatatype.Number },
    _a[task_managed_attributes_types_1.TaskManagedAttributesNames.TimeWindowUpdatedManually] = {
        values: [{ key: true, value: 'Yes' }]
    },
    _a[task_managed_attributes_types_1.TaskManagedAttributesNames.TaskDrivers] = {
        type: types_1.AttributeDatatype.String
    },
    _a[task_managed_attributes_types_1.TaskManagedAttributesNames.DeliveryAssistant] = { entity: types_1.EntityDataType.Driver },
    _a);
function getTaskManagedAttributeMetaData(attributeName) {
    return attributeToDataTypeMapping[attributeName];
}
exports.getTaskManagedAttributeMetaData = getTaskManagedAttributeMetaData;
//# sourceMappingURL=task_managed_attributes_metadata.js.map